<template>
  <NuxtChild
    :initialPostDocuments="postDocuments"
    :hasFetchedPostDocuments="hasFetchedPostDocuments"
  />
</template>

<script>
import { mapActions } from 'vuex'
import ReportService from '@/api/services/report'

export default {
  name: 'ReportYearParent',

  data() {
    return {
      hasFetchedPostDocuments: false,
      postDocuments: [],
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        // Set in store state and not as a getter to avoid flickering where the current report year
        // is displayed to the user
        this.updateCurrentReportYear(this.$route.params.year)
        this.fetchPostDocuments()
      },
    },
  },

  methods: {
    ...mapActions({
      updateCurrentReportYear: 'report/updateCurrentReportYear',
    }),

    async fetchPostDocuments() {
      try {
        const year = Number(this.$route.params.year)

        if (!year) {
          throw new Error(`[fetchPostDocuments] No year provided for ${this.$route.fullPath}`)
        }
        const locale = this.$i18n.__pendingLocale || this.$i18n.locale
        this.postDocuments = await ReportService.fetchPostDocuments({
          client: this.$apolloProvider.defaultClient,
          year,
          locale,
        })
        this.hasFetchedPostDocuments = true
      } catch (err) {
        this.$sentry.captureException(err)
      }
    },
  },
}
</script>
